import { Real } from "@siteimprove/alfa-math";
import { Parser } from "@siteimprove/alfa-parser";
import { Keyword } from "../textual/keyword.js";
import { LengthPercentage } from "../numeric/index.js";
import { Value } from "../value.js";
import { BasicShape } from "./basic-shape.js";
const { either, filter, map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-shapes/#typedef-shape-radius}
 *
 * @public
 */
export class Radius extends BasicShape {
    static of(value) {
        return new Radius(value);
    }
    _value;
    constructor(value) {
        super("radius", Value.hasCalculation(value));
        this._value = value;
    }
    get value() {
        return this._value;
    }
    resolve(resolver) {
        if (Keyword.isKeyword(this._value)) {
            // TS lose the fact that if this._value is a Side, then this must be a
            // Radius<Side>…
            return this;
        }
        const resolved = LengthPercentage.resolve(resolver)(this._value);
        return new Radius(LengthPercentage.of(Real.clamp(resolved.value, 0, Infinity), resolved.unit));
    }
    partiallyResolve(resolver) {
        if (Keyword.isKeyword(this._value)) {
            // TS lose the fact that if this._value is a Side, then this must be a
            // Radius<Side>…
            return this;
        }
        const resolved = LengthPercentage.partiallyResolve(resolver)(this._value);
        if (resolved.hasCalculation()) {
            return Radius.of(resolved);
        }
        const clamped = Real.clamp(resolved.value, 0, Infinity);
        return Radius.of(LengthPercentage.isPercentage(resolved)
            ? LengthPercentage.of(clamped)
            : LengthPercentage.of(clamped, resolved.unit));
    }
    equals(value) {
        return value instanceof Radius && value._value.equals(this._value);
    }
    hash(hash) {
        hash.writeHashable(this._value);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this._value.toJSON(),
        };
    }
    toString() {
        return this.value.toString();
    }
}
/**
 * @public
 */
(function (Radius) {
    function isRadius(value) {
        return value instanceof Radius;
    }
    Radius.isRadius = isRadius;
    Radius.parse = map(either(filter(LengthPercentage.parse, 
    // https://drafts.csswg.org/css-values/#calc-range
    (value) => value.hasCalculation() || value.value >= 0, () => "Radius cannot be negative"), Keyword.parse("closest-side", "farthest-side")), (radius) => Radius.of(radius));
})(Radius || (Radius = {}));
//# sourceMappingURL=radius.js.map